import React from "react";
import { PageHeader } from "./Rentals";

export default function RefundPolicy() {
  return (
    <div>
      <PageHeader eyebrow="Legal" title="Refund Policy" subtitle="Service-specific cancellation and refund guidance for IceFleet bookings." />
      <section className="mx-auto max-w-4xl px-5 sm:px-8 pb-24 space-y-10 text-sm leading-7 text-slate-700">
        <LegalSection title="Airport Transfers">
          <p>Full refund if cancelled at least 24 hours before pickup unless otherwise stated in a custom booking agreement.</p>
        </LegalSection>
        <LegalSection title="Private Tours">
          <p>Refund eligibility depends on notice period, purchased inclusions, and supplier commitments already secured for the tour.</p>
        </LegalSection>
        <LegalSection title="Vehicle Rentals">
          <p>Cancellation fees may apply depending on timing, vehicle allocation, and committed preparation costs.</p>
        </LegalSection>
        <LegalSection title="No-show policy">
          <p>No refund for no-shows unless otherwise agreed in writing.</p>
        </LegalSection>
        <LegalSection title="Refund processing">
          <p>Approved refunds may take several business days depending on the payment provider and banking institution.</p>
        </LegalSection>
      </section>
    </div>
  );
}

function LegalSection({ title, children }) {
  return (
    <div className="space-y-3">
      <h2 className="font-heading text-2xl font-semibold tracking-tight text-slate-900">{title}</h2>
      <div className="space-y-3">{children}</div>
    </div>
  );
}